import React from "react";
import ColorSwatch, { TColorSwatch } from "../components/colorSwatch/colorSwatch";
import { TPaintOrderLineItem } from "../types/api";

export const PaintUtils = {
  getPaintBrandLogo: (paintBrand: string) => {
    switch (paintBrand) {
      case "Behr": {
        return "https://assets.homedepot-static.com/images/v1/paintReorder/behrLogoScaling.svg";
      }
      case "Glidden": {
        return "https://assets.homedepot-static.com/images/v1/paintReorder/gliddenLogoScaling.svg";
      }
      case "Kilz": {
        return "https://assets.homedepot-static.com/images/v1/paintReorder/killzLogoScaling.svg";
      }
      case "Olympic": {
        return "https://assets.homedepot-static.com/images/v1/paintReorder/olympicLogoScaling.svg";
      }
      case "PPG": {
        return "https://assets.homedepot-static.com/images/v1/paintReorder/ppgLogoScaling.svg";
      }
      default: {
        return "";
      }
    }
  },

  assembleSwatches: (paintOrderLineItems: TPaintOrderLineItem[]) => {
    const swatches: Array<TColorSwatch> = [];

    if (paintOrderLineItems) {
      paintOrderLineItems.forEach((paintOrderLineItem, key) => {
        swatches.push(<ColorSwatch key={key} paintOrderData={paintOrderLineItem} />);
      });
    }
    return swatches;
  },

  determineColorTag: (colorType: string, colorWasAdjusted: boolean) => {
    if (colorType === "CustomColor") {
      return "Manual";
    }
    if (colorWasAdjusted) {
      return "Adjusted";
    }
    return "Color Match";
  },

  redirect: (url: string) => {
    window.location.assign(url);
  },
};
